<template>
  <div class="indicator" v-if="range">
    <span>{{ range.low }}</span>
    <div class="progress"></div>
    <span>{{ range.high }}</span>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'OverviewRiskIndicator',
  props: {
    indicatorColor: {
      type: Array
    }
  },
  computed: {
    ...mapState('dashboardServices', ['zoomTreeMap']),
    range () {
      if (this.zoomTreeMap.children && this.zoomTreeMap.children.length) {
        this.setGradientIndicator()
        const records = []
        this.zoomTreeMap.children.forEach(rec => {
          records.push(Number(rec.data_risk_aggregation))
        })
        records.sort((a, b) => {
          return a - b
        })
        return {
          low: records[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
          high: records[records.length - 1].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        }
      }
    }
  },
  methods: {
    setGradientIndicator () {
      this.indicatorColor.sort((a, b) => {
        const c1 = a.split(',')
        const n = Number(c1[0].substring(4)) + Number(c1[1]) + Number(c1[2].slice(0, -1))
        const c2 = b.split(',')
        const n2 = Number(c2[0].substring(4)) + Number(c2[1]) + Number(c2[2].slice(0, -1))

        return n2 - n
      })

      const minColor = this.indicatorColor[this.indicatorColor.length - 1]
      const maxColor = this.indicatorColor[0]
      document.documentElement.style.setProperty('--gradientMin', maxColor)
      document.documentElement.style.setProperty('--gradientMax', minColor)
    }
  }
}
</script>

<style lang="scss" scoped>
  .indicator {
    display: flex;
    align-items: center;
    margin-top: 12px;
    padding-bottom: 17px;
    .progress {
      width: 174px;
      height: 8px;
      background: linear-gradient(170.81deg, $gradientMin 11.07%, $gradientMax 88.93%);
      border-radius: 4px;
      margin: 0 8px;
    }
    span {
      font-weight: 500;
      font-size: 14px;
      color: black;
    }
  }
</style>
